import { useEffect, useMemo } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { NoticeReceipentType, redirectToPages } from "../../../../../../../_helpers/Helpers";
import { 
  Card, 
  CardBody, 
  CardHeader
} from "../../../../../../../_metronic/_partials/controls";
import { ParentsFilter } from "./parents-filter/ParentsFilter";
import { ParentsTable } from "./parents-table/ParentsTable";
import { useParentsUIContext } from "./ParentsUIContext";

export function ParentsCard({
  receipentType,
  setReceipentIds
}) {
  // Parents Card UI Context
  const parentsUIContext = useParentsUIContext();
  const parentsUIProps = useMemo(() => {
    return {
      ids: parentsUIContext.ids
    };
  }, [parentsUIContext]);

  // Getting curret state of Parents from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.privateNotices }),
    shallowEqual
  );  
  const { isSuccess, type, entities } = currentState;

  useEffect(() => {
    if (entities) {
      const selectedEntities = entities.filter(entity => parentsUIProps.ids.includes(entity.id));
      const parentIds = [...new Set(selectedEntities.map(entity => entity.parentId))]
      setReceipentIds(parentIds);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parentsUIProps.ids]);

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  const receipent = receipentType === NoticeReceipentType.Parent ? "Veli" : receipentType === NoticeReceipentType.Father ? "Baba" : receipentType === NoticeReceipentType.Mother ? "Anne" : "";
  const title = <>{receipent} Listesi{parentsUIProps.ids.length > 0 ?
                  <> [Seçilen Kayıt Sayısı: <span style={{color:"red"}}>{parentsUIProps.ids.length}</span>]</> :
                   ""}
                </>;

  return (
    <Card>
      <CardHeader title={title} />
      <CardBody>
        <ParentsFilter />
        <ParentsTable
          receipentType={receipentType}
        />
      </CardBody>
    </Card>
  );
}